import React from "react";
import Tilt from "react-tilt";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { github } from "../assets";
import { SectionWrapper } from "../hoc";
import { HiChevronLeft } from "react-icons/hi";
import { HiChevronRight } from "react-icons/hi";
import { HiExternalLink } from "react-icons/hi";
import { projects } from "../constants";
import { fadeIn, textVariant } from "../utils/motion";

const ProjectCard = ({
  index,
  name,
  description,
  tags,
  image,
  source_code_link,
}) => {
  return (
    <motion.div
      variants={fadeIn("up", "spring", index * 0.5, 0.75)}
      className="inline-block mr-4"
    >
      <Tilt
        options={{
          max: 45,
          scale: 1,
          speed: 450,
        }}
        className="bg-tertiary p-5 rounded-2xl sm:w-[360px] w-full  "
      >
        {/* inline-block mr-2 */}
        <div className="relative w-full h-[230px]">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover rounded-2xl "
          />

          <div className="absolute inset-0 flex justify-end m-3 card-img_hover">
            <div
              onClick={() => window.open(source_code_link, "blank")}
              className="black-gradient w-10 h-10 rounded-full flex justify-center items-center cursor-pointer"
            >
              {/* <img
                src={github}
                alt="github"
                className="w-1/2 h-1/2 object-contain"
              /> */}
               <HiExternalLink className="h-8 w-8 text-white" />
            </div>
          </div>
        </div>

        <div className="mt-5">
          <h3 className="text-white font-bold text-[24px]">{name}</h3>
          <p className="mt-2 text-secondary text-[14px] whitespace-normal">
            {description}
          </p>
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {tags.map((tag) => (
            <p key={tag.name} className={`text-[14px] ${tag.color}`}>
              # {tag.name}
            </p>
          ))}
        </div>
      </Tilt>
    </motion.div>
  );
};

const Works = () => {

  const slideLeft = () => {
    var slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft - 500;
  };

  const slideRight = () => {
    var slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft + 500;
  };

  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}> My Work </p>
        <h2 className={styles.sectionHeadText}> Projects. </h2>
      </motion.div>

      <div className="w-full">
        <motion.p
          variants={fadeIn("", "", 0.1, 1)}
          className="mt-3 text-secondary text-[17px] max-w-[3xl] leading-[30px]"
        >
          The Following projects showcase my skills and experience through
          real-world examples of my work. Each project is briefly described with
          links to code repositories or live demos in it. It reflects my
          ability to embrace the power of technology to solve real-world complex problems. 
        </motion.p>

        {/* overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide */}
        {/* flex flex-col md:flex-row gap-7 bg-red-800 */}

        <div className="flex items-center justify-between space-x-3 p-2 ">
          <div
            onClick={slideLeft}
            className="bg-gray-900 text-gray-600 rounded-full p-1 cursor-pointer hidden md:inline-flex"
          >
            <HiChevronLeft className="h-10 w-10 text-white" />
          </div>

          {/* Slider */}
          <div
            id="slider"
            className="mt-20 p-3 overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide gap-7"
          >
            {projects.map((project, index) => (
              <ProjectCard
                key={`project-${index}`}
                index={index}
                {...project}
              />
            ))}
          </div>

          <div
            onClick={slideRight}
            className="bg-gray-900 text-gray-600 rounded-full p-1 cursor-pointer hidden md:inline-flex "
          >
            <HiChevronRight className="h-10 w-10 text-white" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionWrapper(Works, "");
